import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var FavoriteSpeakerIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("path", {
                            d: "M12.055 20.042l.8.42c.23.12.5-.07.46-.33l-.15-.89c-.02-.1.02-.21.09-.28l.65-.63c.19-.18.08-.5-.17-.54l-.9-.13a.351.351 0 01-.24-.17l-.4-.81c-.12-.23-.45-.23-.56 0l-.4.81c-.05.09-.13.16-.24.17l-.9.13c-.26.04-.36.35-.17.54l.65.63c.07.07.11.18.09.28l-.15.89c-.04.26.23.45.46.33l.8-.42a.3.3 0 01.29 0h-.01z",
                            fillRule: "evenodd",
                            clipRule: "evenodd"
                        }),
                        _jsx("path", {
                            d: "M11.995 9.942c2.06 0 3.73-1.66 3.73-3.72 0-2.06-1.67-3.72-3.73-3.72s-3.73 1.67-3.73 3.72c0 2.05 1.67 3.72 3.73 3.72zm.01-5.44c.96 0 1.73.77 1.73 1.72s-.77 1.72-1.73 1.72-1.73-.77-1.73-1.72.77-1.72 1.73-1.72zm7.99 9h-2.77c-.45-1.72-2-3-3.86-3h-2.73c-1.86 0-3.41 1.28-3.86 3h-2.77c-.55 0-1 .45-1 1s.45 1 1 1h1.15l.86 5.16c.09.54.6.92 1.15.82.54-.09.91-.61.82-1.15l-.81-4.84h9.64l-.81 4.84c-.09.54.28 1.06.82 1.15.06 0 .11.01.17.01.48 0 .9-.35.99-.84l.86-5.16h1.15c.55 0 1-.45 1-1s-.45-1-1-1v.01zm-9.36-1h2.73c.73 0 1.37.41 1.72 1h-6.17c.35-.59.99-1 1.72-1z"
                        })
                    ]
                })
            })
        ]
    });
};
FavoriteSpeakerIcon.isCarinaIcon = true;
export default FavoriteSpeakerIcon;
